import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2, Lock } from 'lucide-react';
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
  }
}
export function CTASection() {
  return <section className="py-20 bg-brand-dark text-white relative overflow-hidden" data-id="element-1">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-terracotta/20 rounded-full blur-[100px] pointer-events-none" data-id="element-2"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-3">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-4">
          <h2 className="font-serif text-3xl md:text-5xl font-bold mb-6 text-brand-cream" data-id="element-5">
            Recupera tu cuerpo y tu energía hoy mismo
          </h2>
          <p className="font-sans text-xl text-brand-cream/80 mb-10 max-w-2xl mx-auto" data-id="element-6">
            Deja de adivinar y empieza a aplicar un método probado. Únete a las
            más de 1,200 mujeres que ya han tomado el control.
          </p>

          <div id="cta-precio" className="bg-white text-brand-dark p-8 rounded-2xl shadow-2xl max-w-md mx-auto transform hover:scale-105 transition-transform duration-300" data-id="element-7">
            <div className="text-center mb-6" data-id="element-8">
              <span className="bg-brand-terracotta/10 text-brand-terracotta text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-9">
                🔥 93% de descuento — Solo por hoy
              </span>
            </div>

            <div className="flex justify-center items-baseline gap-3 mb-1" data-id="element-10">
              <span className="text-5xl font-bold text-brand-terracotta" data-id="element-11">
                $6.39
              </span>
              <div className="flex flex-col items-start" data-id="element-12">
                <span className="text-sm text-gray-400 line-through leading-none" data-id="element-13">
                  $97.00
                </span>
                <span className="text-xs text-brand-sage font-bold" data-id="element-14">USD</span>
              </div>
            </div>
            <p className="text-center text-xs font-bold text-brand-sage mb-1" data-id="element-15">
              Ahorras $90.61 hoy
            </p>
            <p className="text-sm text-gray-500 mb-8 text-center" data-id="element-16">
              Pago único • Acceso de por vida
            </p>

            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} animate={{
            boxShadow: ['0px 0px 0px rgba(196, 97, 74, 0)', '0px 0px 20px rgba(196, 97, 74, 0.5)', '0px 0px 0px rgba(196, 97, 74, 0)']
          }} transition={{
            duration: 2,
            repeat: Infinity,
            repeatType: 'loop'
          }} onClick={() => {
            if (typeof window.fbq === 'function') {
              window.fbq('track', 'AddToCart', {
                value: 6.39,
                currency: 'USD',
                content_name: 'SOS Premenopausia'
              });
            }
            window.open('https://rutinasimple.com//cart/52019182240025:1', '_blank');
          }} className="w-full bg-brand-terracotta hover:bg-brand-terracotta-dark text-white font-bold py-4 px-6 rounded-lg shadow-lg flex items-center justify-center space-x-2 mb-4 transition-colors" data-id="element-17">
              <span data-id="element-18">OBTENER ACCESO INMEDIATO</span>
              <ArrowRight className="w-5 h-5" data-id="element-19" />
            </motion.button>

            <div className="flex items-center justify-center space-x-2 text-xs text-gray-500 mb-6" data-id="element-20">
              <Lock className="w-3 h-3" data-id="element-21" />
              <span data-id="element-22">Pago 100% Seguro y Encriptado</span>
            </div>

            <div className="space-y-3 text-left" data-id="element-23">
              {['Acceso inmediato al protocolo completo', 'Menús y recetas antiinflamatorias', 'Bonus de ejercicios y sueño', 'Garantía de devolución de 30 días'].map((item, i) => <div key={i} className="flex items-center text-sm text-gray-700" data-id="element-24">
                  <CheckCircle2 className="w-4 h-4 text-brand-sage mr-2 flex-shrink-0" data-id="element-25" />
                  <span data-id="element-26">{item}</span>
                </div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}